import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { ViewManager } from '../../core/view-manager';
import { LanguageProvider } from '../../core/language-provider';
import { Utils } from '../../core/utils';
import _ from "lodash";
import MPTH_item_model from '../components/MPTH/MPTH_item_model';
import MPTH_customer_offices from '../components/MPTH/MPTH_customer_offices';
import { toast } from 'react-toastify';




export default function StandardViewBottomHook({ data, entity = null, searchObj, setSearchObj, selected }) {

    useEffect(() => {
    }, []);


    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'item_model': return (
                            <MPTH_item_model entity={entity} data={data} searchObj={searchObj} setSearchObj={setSearchObj} />
                        );
                        case 'customer_offices': return (
                            <>
                                <MPTH_customer_offices entity={entity} data={data} searchObj={searchObj} setSearchObj={setSearchObj} />
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};